import { Row, Col, Container } from "react-bootstrap";
import Styles from "./index.module.css";
import SideBarAds from "../Ads/sidebar";
import HeaderAds from "../Ads/header";

const WithSideBarADS = ({ children }) => {
  return (
    <Container>
      <Row>
        <Col>
          <div className={Styles.card}>
            <HeaderAds />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={9}>
          <div className={Styles.card}>{children}</div>
        </Col>
        <Col xs={3}>
          <div className={Styles.card}>
            <SideBarAds />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default WithSideBarADS;
